/**
 * CDA opt-in defaults (MC-12688).
 * Baked into the build — deploy env is optional; these work without VUE_APP_* vars.
 */

/** Public CRM base for /optin/status + /subscribe/v2 */
export const DEFAULT_CRM_BASE_URL =
  'https://api-migdal.travelfactory.fr/public/crm'

/** Allowlist: `*` = everyone. Override with VUE_APP_CDA_OPTIN_USER_IDS if needed. */
export const DEFAULT_CDA_OPTIN_USER_IDS = '*'
